<template>
    <b-col lg="4">
        <div class="form-item form-item-text" :class="{ 'field-error': errors.has('birth_date') && showErrors }">
            <label class="form-label">
                Birth date
            </label>
            <div class="date--outer">
                <datepicker :disabled="sending"
                            :options="{ mode: 'single', maxDate: 'today', defaultDate: fieldValue }"
                            v-model="fieldValue"
                            v-if="!isVerified"></datepicker>
                <input type="text"
                       id="user_data_birth_date"
                       name="birth_date"
                       v-model="fieldValue"
                       v-validate
                       data-vv-as="birth date"
                       data-vv-rules="required"
                       :readonly="true"
                       :disabled="sending || isVerified">
            </div>

            <p class="field-error--description" v-show="errors.has('birth_date') && showErrors">{{ errors.first('birth_date') }}</p>
        </div>
    </b-col>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: ['updateValue', 'sending', 'showErrors', 'isVerified'],
        data () {
            return {
                fieldValue: ''
            }
        },
        computed: {
            defaultValue () {
                return this.$store.getters.user.birthDate;
            }
        },
        watch: {
            defaultValue () {
                this.fieldValue = this.defaultValue;
            },

            fieldValue () {
                this.updateValue('birthDate', this.fieldValue);
            }
        },
        mounted () {
            this.fieldValue = this.defaultValue;
            this.updateValue('birthDate', this.fieldValue);
        }
    }
</script>

<style lang="scss">
    @import '../../../../../../assets/scss/_colors.scss';

    .datepicker{
        .fa{
            display: none;
        }
    }

    .date--outer{
        position: relative;

        .datepicker{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 3;
        }
    }

    :disabled{
        cursor: not-allowed;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile-edit-data/Birthdate.vue